import Icon from '../components/Icon.vue'

Icon.register({
  'mars-stroke': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 64H293C282.3 64 277 76.9 284.5 84.5L301.4 101.4 283.9 118.9 269.8 104.8C265.1 100.1 257.5 100.1 252.8 104.8L224.5 133C219.8 137.7 219.8 145.3 224.5 150L238.6 164.1 220.6 182.1C198.4 168.1 172.1 160 143.9 160 64.5 160 0 224.5 0 304S64.5 448 144 448 288 383.5 288 304C288 275.8 279.9 249.5 265.9 227.3L283.9 209.3 298 223.4C302.7 228.1 310.3 228.1 315 223.4L343.3 195.1C348 190.4 348 182.8 343.3 178.1L329.2 164 346.7 146.5 363.6 163.4C371.2 171 384.1 165.6 384.1 154.9V76C384 69.4 378.6 64 372 64zM144 384C99.9 384 64 348.1 64 304S99.9 224 144 224 224 259.9 224 304 188.1 384 144 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mars-stroke.js
// module id = oqs0
// module chunks = 144